

















































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Coupon } from '@/core/ApiTypes'
import appManager from '@/services/AppManager'
import * as api from '@/services/ApiService'
import Spinner from '@/components/Spinner.vue'
import CreateCouponDialog from '@/components/coupons/CreateCouponDialog.vue'
import { AppColors } from '@/model/AppColors'
import { getCurrencyText, getDateTextFromMillis, isCouponAvailable } from '@/model/Helpers'
import { CouponDurations } from '@/extern/StripeTypes'

@Component({
    components: {
        Spinner,
        CreateCouponDialog
    }
})
export default class CouponsView extends Vue {
    isLoadingCoupons: boolean = false
    coupons: Coupon[] = []
    couponsSnapshotCounter: number = 0 // simple way to force a refresh when new items arise
    hasMoreCoupons: boolean = false

    // create coupon dialog
    isCreateCouponDialogVisible: boolean = false
    createCouponDialogCounter: number = 0 // simple way to reset the dialog each time it is opened

    // delete coupon variables
    deleteCouponId: string|null = null
    isDeleteCouponDialogVisible: boolean = false
    isDeletingCoupon: boolean = false

    // noinspection JSUnusedGlobalSymbols
    async created() {
        await this.loadMoreCoupons()
    }

    async loadMoreCoupons(): Promise<void> {
        this.isLoadingCoupons = true

        try {
            const response = await api.queryCoupons({
                startAfterStripeCouponId: (this.coupons.length > 0) ? this.coupons[this.coupons.length-1].id : undefined,
                limit: 10,
            })
            for (const coupon of response.coupons)
                this.coupons.push(coupon)
            this.hasMoreCoupons = response.hasMore
            this.couponsSnapshotCounter += 1
        } catch (error) {
            console.error(`Error Loading Coupons: ${error}`)
            appManager.alertManager.publishError('Error loading coupons. Please try again later.')
        }

        this.isLoadingCoupons = false
    }

    isCouponAvailableLocal(coupon: Coupon): boolean {
        return isCouponAvailable(coupon)
    }

    getCouponStatusColor(coupon: Coupon): string {
        return this.isCouponAvailableLocal(coupon) ? AppColors.accent : AppColors.info
    }

    getDurationText(coupon: Coupon): string {
        switch (coupon.data.duration) {
            case CouponDurations.forever:
                return 'forever';
            case CouponDurations.once:
                return 'one time';
            case CouponDurations.repeating:
                return `${coupon.data.durationMonths} mo`;
        }

        return 'UNK'
    }

    getAmountText(coupon: Coupon): string {
        return getCurrencyText(coupon.data.amountOff, coupon.data.amountOffCurrency)
    }

    getDateTextFromMillisLocal(millis: number|null|undefined): string {
        return getDateTextFromMillis(millis)
    }

    onAddCouponPressed() {
        this.createCouponDialogCounter += 1
        this.isCreateCouponDialogVisible = true
    }

    onCloseCreateCouponDialogRequested(newCoupon?: Coupon) {
        if (newCoupon) {
            this.coupons.splice(0, 0, newCoupon)
            this.couponsSnapshotCounter += 1
        }
        this.isCreateCouponDialogVisible = false
    }

    onDeleteCouponPressed(couponId: string) {
        this.deleteCouponId = couponId
        this.isDeleteCouponDialogVisible = true
        this.isDeletingCoupon = false
    }

    async onDeleteCouponConfirmed() {
        if (!this.deleteCouponId)
            return

        console.info(`Deleting Coupon: ${this.deleteCouponId}`)
        this.isDeleteCouponDialogVisible = false
        this.isDeletingCoupon = true

        try {
            await api.deleteCoupon({ stripeCouponId: this.deleteCouponId })

            // remove this coupon from the local list
            this.coupons = this.coupons.filter(c => c.id !== this.deleteCouponId)
            this.couponsSnapshotCounter += 1

            appManager.alertManager.publishSuccess('Coupon successfully deleted')
        } catch (error) {
            console.error(`Error Deleting Coupon: ${error}`)
            appManager.alertManager.publishError('Error deleting coupon. Please try again later.')
        }

        this.deleteCouponId = null
        this.isDeletingCoupon = false
    }
}
